module.exports = "<section class=\"normalHeight\">\n  <div class=\"container\">\n    \n  </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/nosotros/nosotros.component.html
// module id = ../../../../../src/app/nosotros/nosotros.component.html
// module chunks = main